<template>
  <div class="checkInfo">
    <div class="detail">
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="width4 fontBold">物件番号</div>
          <div>{{ paintDetail.wujian_id }}</div>
        </div>
        <div class="detailDiv">
          <div class="width4 fontBold">物件名</div>
          <div style="margin-left: 10%">{{ paintDetail.wujian_name }}</div>
        </div>
      </div>
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="width4 fontBold">生产批号</div>
          <div>{{ paintDetail.batch_no }}</div>
        </div>
        <div class="detailDiv">
          <div class="width4 fontBold">型材番号</div>
          <div>{{ paintDetail.xingcai_no }}</div>
        </div>
      </div>
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="width4 fontBold">涂装色番号</div>
          <div>{{ paintDetail.color_no }}</div>
        </div>
        <div class="detailDiv">
          <div class="width4 fontBold">涂料名</div>
          <div>{{ paintDetail.paint_name }}</div>
        </div>
      </div>
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="width4 fontBold">检查本数</div>
          <div>{{ paintDetail.checked_count }}</div>
        </div>
        <div class="detailDiv">
          <div class="width4 fontBold">再手配编号</div>
          <div>{{ paintDetail.zaishoupei_no }}</div>
        </div>
      </div>
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="width4 fontBold">良品本数</div>
          <div>{{ paintDetail.waiguan_pass }}</div>
        </div>
        <div class="detailDiv">
          <div class="width4 fontBold">不良本数</div>
          <div>{{ paintDetail.ngCount }}</div>
        </div>
      </div>
      <div class="nowrapDiv">
        <div class="width3 fontBold">涂装式样</div>
        <div>{{ paintDetail.specification_name }}</div>
      </div>
    </div>
    <div class="detail">
      <el-table :data="paintList" border stripe style="width: 100%">
        <el-table-column prop="check_no" align="center" label="检查编号" width="150"></el-table-column>
        <el-table-column prop="qclResult" align="center" label="前处理" width="100">
          <template #default="scope">
            <text style="color: green" v-if="scope.row.qclResult==='合格' || scope.row.qclResult==='重检合格'">{{ scope.row.qclResult }}</text>
            <text style="color: red" v-else-if="scope.row.qclResult==='不合格' || scope.row.qclResult==='重检不合格'">{{ scope.row.qclResult }}</text>
            <text v-else>{{ scope.row.qclResult }}</text>
          </template>
        </el-table-column>
        <el-table-column prop="mhResult" align="center" label="膜厚" width="100">
          <template #default="scope">
            <text style="color: green" v-if="scope.row.mhResult==='合格' || scope.row.mhResult==='重检合格'">{{ scope.row.mhResult }}</text>
            <text style="color: red" v-else-if="scope.row.mhResult==='不合格' || scope.row.mhResult==='重检不合格'">{{ scope.row.mhResult }}</text>
            <text v-else>{{ scope.row.mhResult }}</text>
          </template>
        </el-table-column>
        <el-table-column prop="gzResult" align="center" label="光沢" width="100">
          <template #default="scope">
            <text style="color: green" v-if="scope.row.gzResult==='合格' || scope.row.gzResult==='重检合格'">{{ scope.row.gzResult }}</text>
            <text style="color: red" v-else-if="scope.row.gzResult==='不合格' || scope.row.gzResult==='重检不合格'">{{ scope.row.gzResult }}</text>
            <text v-else>{{ scope.row.gzResult }}</text>
          </template>
        </el-table-column>
        <el-table-column prop="sdResult" align="center" label="色调" width="100">
          <template #default="scope">
            <text style="color: green" v-if="scope.row.sdResult==='合格' || scope.row.sdResult==='重检合格'">{{ scope.row.sdResult }}</text>
            <text style="color: red" v-else-if="scope.row.sdResult==='不合格' || scope.row.sdResult==='重检不合格'">{{ scope.row.sdResult }}</text>
            <text v-else>{{ scope.row.sdResult }}</text>
          </template>
        </el-table-column>
        <el-table-column prop="wgResult" align="center" label="外观" width="100">
          <template #default="scope">
            <text style="color: green" v-if="scope.row.wgResult==='合格' || scope.row.wgResult==='重检合格'">{{ scope.row.wgResult }}</text>
            <text style="color: red" v-else-if="scope.row.wgResult==='不合格' || scope.row.wgResult==='重检不合格'">{{ scope.row.wgResult }}</text>
            <text v-else>{{ scope.row.wgResult }}</text>
          </template>
        </el-table-column>
        <el-table-column prop="completed_count" align="center" label="数量" width="100"></el-table-column>
        <el-table-column align="center" label="操作" width="95">
          <template #default="scope">
            <FrameButton
                :key="scope.row.id"
                :button="buttonType"
                :parentData="scope.row"
            ></FrameButton>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>

export default {
  name: "TuZhuangCheckInfo",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      paintDetail: {},
      paintList: [],
      qclList: [],
      mhList: [],
      wgList: [],
      buttonType: {
        component: "button",
        type: "primary",
        label: "检查详情",
        style: "color:#409EFF",
        action_type: "open_window",
        link:true,
        window: {
          width: 600,
          height: 500,
          component: "bus/TuZhuangQcl",
          title: "检查详情"
        }
      }
    }
  },
  methods: {
    async getPaintDetail() {
      let {data: res} = await this.$axios.get('/api/paint/detail?id=' + this.parentData.id);
      if (res.message !== "") {
        this.$message.error(res.message);
      } else {
        this.paintDetail = res.data
        this.paintDetail.ngCount = this.paintDetail.total_count - this.paintDetail.waiguan_pass
      }
    },
    async getPaintCheckWaiGuanList() {
      let {data: res} = await this.$axios.get('/api/paint/check/list?paintId=' + this.parentData.id + '&paintType=' + this.parentData.paint_type);
      if (res.message !== "") {
        this.$message.error(res.message);
      } else {
        this.qclList = res.data
      }

      let {data: res1} = await this.$axios.get('/api/paint/check/thickness/list?paintId=' + this.parentData.id + '&paintType=' + this.parentData.paint_type);
      if (res1.message !== "") {
        this.$message.error(res1.message);
      } else {
        this.mhList = res1.data
      }

      let {data: res2} = await this.$axios.get('/api/paint/waiguan/list?paintId=' + this.parentData.id + '&paintType=' + this.parentData.paint_type);
      if (res2.message !== "") {
        this.$message.error(res2.message);
      } else {
        for (var a = 0; a < this.qclList.length; a++) {
          this.paintList.push(this.qclList[a])
        }
        for (var b = 0; b < this.mhList.length; b++) {
          this.paintList.push(this.mhList[b])
        }
        for (var c = 0; c < res2.data.length; c++) {
          this.paintList.push(res2.data[c])
        }
      }
    },
  },
  created() {
    this.getPaintDetail()
    this.getPaintCheckWaiGuanList()
  }
}
</script>

<style scoped>
.checkInfo {
  background-color: #F4F8FD;
}

.detail {
  background-color: #FFFFFF;
  margin: 5px;
  border-radius: 5px;
  padding: 5px;
  font-size: 16px;
}

.detailDiv {
  width: 50%;
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fontBold {
  font-weight: bold;
}

.width1 {
  width: 25%;
}

.width2 {
  width: 39%;
}

.width3 {
  width: 11%;
}

.width4 {
  width: 22%;
}

.width5 {
  width: 50%;
}

.nowrapDiv {
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ngdiv {
  width: 50px;
  height: 25px;
  background-color: #F1F1F1;
  margin-right: 5px;
  margin-bottom: 5px;
}

.ngdiv1 {
  font-size: 12px;
  width: 50px;
  height: 25px;
  background-color: #1A73E8;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  margin-bottom: 5px;
}

.imageStyle {
  width: 87px;
  height: 87px;
  margin-right: 5px
}
</style>
